import { EMAIL_ADDRESS } from "./siteContent";

// ── API Endpoints ────────────────────────────────────────────
export const INIT_URL = "/api/init";
export const WAITLIST_API_URL = "/api/subscribeWaitinglist";
export const ORDER_API_URL = "/api/saveOrder";
export const NEWSLETTER_API_URL = "/api/subscribeNewsletter";
export const UNSUBSCRIBE_NEWSLETTER_API_URL = "/api/unsubscribeNewsletter";
export const UNSUBSCRIBE_WAITINGLIST_API_URL = "/api/unsubscribeWaitinglist";

// ── PayPal ───────────────────────────────────────────────────
//forniti da https://developer.paypal.com/
//L'account business sandbox è quello impostato qui in URL che riceve
//L'account personal sandbox è quello che invia, da usare durante l'acquisto sul sito:
//user personal: sb-43zb6g35101951@personal.example.com
//passoword personal: R.5S))v$
const PAYPAL_CLIENT_ID_LIVE = "Aclo6uAjX4ydLBNEkWp2AzmmufRAzlcwISb7c3A6Du-QHpKXdrT-I-ACnS_ojl3UV9i-MthgdqBBce7p";
const PAYPAL_CLIENT_ID_SANDBOX = "Ac1n0f44oYU4Sy7mSmhT7na-sq7-qPG8lii4mUvlHjGvCO87juS7Y5SR9HqLqiP_wnw_9ATXaazmRXat";
const PAYPAL_BUSINESS_SANDBOX = "sb-ugj2v35162648@business.example.com";
export const PAYPAL_CURRENCY = "EUR";

export const getPaypalClientId = sandbox => (sandbox ? PAYPAL_CLIENT_ID_SANDBOX : PAYPAL_CLIENT_ID_LIVE);
export const getPaypalSdkUrl = sandbox =>
  `https://www.${sandbox ? "sandbox." : ""}paypal.com/sdk/js?client-id=${getPaypalClientId(sandbox)}&currency=${PAYPAL_CURRENCY}`;

const SITE_BASE_URL = "https://www.dawnedinstruments.com";

//sto passando in URL anche il notifyURL, in teoria, se cambia, va aggiornato anche qui: https://www.paypal.com/merchantnotification/ipn/preference
//punta alla risorsa API che gestisce il pagamento, in questo caso con Vercel API, a https://www.dawnedinstruments.com/api/ipnHandler
export const buildPaypalIpnUrl = (total, orderId, sandbox) =>
  `https://www.${sandbox ? "sandbox." : ""}paypal.com/cgi-bin/webscr?cmd=_xclick` +
  `&business=${sandbox ? PAYPAL_BUSINESS_SANDBOX : EMAIL_ADDRESS}` +
  `&item_name=Acquisto%20dal%20tuo%20sito` +
  `&amount=${total.toFixed(2)}` +
  `&currency_code=${PAYPAL_CURRENCY}` +
  `&custom=${orderId}` +
  `&notify_url=${SITE_BASE_URL}/api/ipnHandler` +
  `&return=${SITE_BASE_URL}/?success=true` +
  `&cancel_return=${SITE_BASE_URL}/?success=false`;

// ── Social Media ─────────────────────────────────────────────
export const LINKS = {
  instagram: "https://www.instagram.com/dawned_instruments/",
  youtube: "https://www.youtube.com/@dawned_instruments",
  tiktok: "https://www.tiktok.com/@dawned_instruments",
  modulargrid: "https://modulargrid.net/e/vendors/view/1254",
};
